// Components==============
import './PortfolioShareCode.module.scss';
import { faCopy, faPen } from '@fortawesome/pro-solid-svg-icons';
import { faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { motion } from 'framer-motion';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import { MyPortfolioContext } from 'pages/Portfolio/MyPortfolios/MyPortfolio';
// =========================
type Status = 'inactive' | 'copied';

const variantsLeft = {
  inactive: {
    color: '#0827e9',
  },
  copied: {
    color: '#2addd0',
  },
};

const variantsRight = {
  inactive: {
    background: '#0827e9',
  },
  copied: {
    background: '#2addd0',
  },
};

export default function PortfolioShareCode() {
  const translate = useTranslate();
  const [status, setStatus] = useState<Status>('inactive');

  const { currentPortfolio, handleUrlChange } = useContext(MyPortfolioContext);

  const [value, setValue] = useState(currentPortfolio?.share_code || '');
  const [editingShareCode, setEditingShareCode] = useState(false);

  useEffect(() => {
    setValue(currentPortfolio?.share_code || '');
  }, [currentPortfolio?.share_code]);

  if (!currentPortfolio?.share_code) return <></>;

  function copiedClick() {
    navigator.clipboard.writeText(
      `learntogroow.com/publiek-portfolio/${value}`
    );
    setStatus('copied');
    setTimeout(function () {
      setStatus('inactive');
    }, 2000);
  }

  return (
    <div styleName="sharecode-button">
      <Tooltip
        fullWidth
        position="bottom"
        content={<p>{translate('portfolio.sharecode-tooltip-portfolio')}</p>}
      >
        <motion.div
          variants={variantsLeft}
          animate={status}
          initial="inactive"
          styleName="left"
        >
          <p>learntogroow.com/publiek-portfolio/</p>
          <form
            styleName="input-wrapper"
            onSubmit={(e) => {
              e.preventDefault();
              handleUrlChange(value);
              setEditingShareCode(false);
            }}
          >
            <input
              styleName={editingShareCode ? 'editing' : ' '}
              onChange={(e) => {
                if (e.target.value.includes(' ')) {
                  return false;
                }
                setValue(e.target.value);
              }}
              readOnly={!editingShareCode}
              value={value}
            />
            <div styleName="input-icons">
              {editingShareCode ? (
                <>
                  <FontAwesomeIcon
                    onClick={() => {
                      setValue(currentPortfolio.share_code);
                      setEditingShareCode(false);
                    }}
                    icon={faTimes}
                  />
                  <button type="submit">
                    <FontAwesomeIcon icon={faCheck} />
                  </button>
                </>
              ) : (
                <>
                  <FontAwesomeIcon
                    onClick={() => {
                      setEditingShareCode(true);
                    }}
                    icon={faPen}
                  />
                </>
              )}
            </div>
          </form>
        </motion.div>
      </Tooltip>
      <motion.div
        whileHover={status !== 'copied' ? { background: '#2c48f8' } : undefined}
        variants={variantsRight}
        animate={status}
        initial="inactive"
        styleName="right"
        onClick={() => {
          copiedClick();
        }}
      >
        <FontAwesomeIcon icon={status === 'inactive' ? faCopy : faCheck} />
      </motion.div>
    </div>
  );
}
